import { Box, Grid } from "@mui/material"

export const Tfooter = ({salesBranchList}) => {

    let totalsales = salesBranchList.reduce((prev, current) => {
        return prev + +current.total_sales;
    }, 0);
    let totalactualsales = salesBranchList.reduce((prev, current) => {
        return prev + +current.actual_sales;
    }, 0);
    let totalreconsales = salesBranchList.reduce((prev, current) => {
        return prev + +current.reconciled_sales;
    }, 0);
    let total_variance = salesBranchList.reduce((prev, current) => {
        return prev + + (!!current.reconciled_sales ? current.recon_variance : current.variance);
    }, 0);
    
    return (
        <Box minHeight="70px">
            <Grid container direction="row" sx={{ py:1.5, px:2}}>
                <Grid item xs={2}></Grid>
                <Grid item xs={2}></Grid>
                <Grid item xs={1} textAlign="center"></Grid>
                <Grid item xs={2} textAlign="center" fontWeight={700}>{`₱ ${parseFloat(totalsales).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</Grid>
                <Grid item xs={2} textAlign="center" fontWeight={700}>{`₱ ${parseFloat(totalactualsales).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</Grid>
                <Grid item xs={2} textAlign="center" fontWeight={700}>{`₱ ${parseFloat(totalreconsales).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</Grid>
                <Grid item xs={1} textAlign="center" fontWeight={700}>{`₱ ${parseFloat(total_variance).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</Grid>
            </Grid>
            <Grid container direction="row" sx={{ px:2}}>
                <Grid item xs={2}></Grid>
                <Grid item xs={2}></Grid>
                <Grid item xs={1} textAlign="center"></Grid>
                <Grid item xs={2} textAlign="center" fontWeight={700}>Total Sales</Grid>
                <Grid item xs={2} textAlign="center" fontWeight={700}>Total Actual Sales</Grid>
                <Grid item xs={2} textAlign="center" fontWeight={700}>Total Reconciled Sales</Grid>
                <Grid item xs={1} textAlign="center" fontWeight={700}>Total Variance</Grid>
            </Grid>
        </Box>
    )
}